import { useEffect, useState } from "react";
import { SessionHandler } from "verdi-web-client";

/**
 * The selected account, re-read on every event that can change it.
 *
 * `SessionHandler.curUser` is a plain mutable field, so anything gated on it needs these events to
 * notice it arrived or went away. Logout clears it without firing a session event.
 */
export const useSelectedAccount = (): string | undefined => {
    const [account, setAccount] = useState(SessionHandler.curUser);

    useEffect(() => {
        const sync = () => setAccount(SessionHandler.curUser);
        SessionHandler.onSessionLoad.addListener(sync);
        SessionHandler.onSessionUnload.addListener(sync);
        SessionHandler.onLogOut.addListener(sync);
        // The initial value was read during render; an event between then and now was missed.
        sync();

        return () => {
            SessionHandler.onSessionLoad.removeListener(sync);
            SessionHandler.onSessionUnload.removeListener(sync);
            SessionHandler.onLogOut.removeListener(sync);
        };
    }, []);

    return account;
};
